import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { ICONS } from '@core/services/icons/icons.service';

import { AuthLayoutComponent } from '@features/components/login/auth-layout/auth-layout.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [TranslatePipe, AuthLayoutComponent],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  protected readonly emailIcon = ICONS.envelope;

  login(): void {
    this.oidcSecurityService.authorize();
  }
}
